import './css/react.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { store } from './store'
import { Provider } from 'react-redux'


ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Router>
        <Route component={App}/>
      </Router>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);